import { Category } from "../../types/blogTyps/BlogCategory";


export const categories: Category[] = [
  { id: 1, name: "All" },
  { id: 2, name: "Medical Insights" },
  { id: 3, name: "Patient Care" },
  { id: 4, name: "Wellness Tips" },
  { id: 5, name: "Hospital News" },
  { id: 6, name: "Specialized Care" },
  // { id: 7, name: "Health Education", count: 2 },
  // { id: 8, name: "Doctor's Corner", count: 2 },
  // { id: 9, name: "Preventive Care", count: 2 },
  // { id: 10, name: "Technology in Healthcare", count: 2 },
];

